import { render, staticRenderFns } from "./billOfParcels.vue?vue&type=template&id=74335fce&scoped=true&"
import script from "./billOfParcels.vue?vue&type=script&lang=js&"
export * from "./billOfParcels.vue?vue&type=script&lang=js&"
import style0 from "./billOfParcels.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./billOfParcels.vue?vue&type=style&index=1&id=74335fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74335fce",
  null
  
)

export default component.exports